import { useState } from 'react';

import dayjs from 'dayjs';

// Every day (YYYY-MM-DD) from this Monday to today, in UTC. This is the range
// the page opens on; Rangebar computes the other ranges when one is picked.
const currentWeekKeys = () => {
    let now = dayjs();
    now = now.subtract(now.utcOffset(), 'minute');
    const start_time = now.subtract((now.day() + 6) % 7, 'day').startOf('day');
    const end_time = now.endOf('day');
    const keys = [];
    let start = start_time;
    while (start <= end_time) {
        keys.push(start.format('YYYY-MM-DD'));
        start = start.add(1, 'day');
    }
    return keys;
};

function useOverviewRange() {
    const [rangetype, setRangetype] = useState('r1');
    const [timeKeys, setTimeKeys] = useState(currentWeekKeys);
    return { rangetype, setRangetype, timeKeys, setTimeKeys };
}

export default useOverviewRange;
